const FAKTUROWNIA_INTEGRATION_TYPES = {
  advance: 'ADVANCE',
  disabled: 'DISABLED',
  invoice: 'INVOICE',
  receipt: 'RECEIPT',
};

export default FAKTUROWNIA_INTEGRATION_TYPES;
